<template>
  <div class="smartEnergyWrap mainPageBg">
    <div class="title" id="svgContent">
      <SvgTitle :key="svgKey" svgId="svgSmartEnergy" svgUrl="@/assets/images/msgt/homeTitle.svg" />
    </div>
    <div class="content">
      <div class="content-left">
        <LeftPanel />
      </div>
      <div class="content-center">
        <CenterPanel />
      </div>
      <div class="content-right">
        <RightPanel />
      </div>
    </div>

  </div>
</template>

<script>
import LeftPanel from "@/components/smartEnergy/LeftPanel/LeftPanel";
import CenterPanel from "@/components/smartEnergy/CenterPanel/CenterPanel";
import RightPanel from "@/components/smartEnergy/RightPanel/RightPanel";
import SvgTitle from "@/components/Svg/SvgTitle";
export default {
  name: "SmartEnergy",
  props: {},
  components: {
    SvgTitle,LeftPanel, CenterPanel, RightPanel
  },
  data() {
    return {
      svgKey: 1,
    }
  },
  computed: {},
  methods: {},
  created() {
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.smartEnergyWrap {
  background: #050b1f;

  .title {
    width: 100%;
    height: 80px;
  }

  .content {
    padding: 0 16px;
    height: calc(100% - 96px);
    display: flex;
    @include setFlexBetween;
    background: url("~@/assets/images/msgt/backgroud.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &-left {
      width: 484px;
      height: 100%;
      flex-grow: 0;
    }

    &-center {
      width: calc(100% - 1020px);
      height: 100%;
      flex-grow: 1;
      margin: 0 10px;
    }

    &-right {
      width: 484px;
      height: 100%;
      flex-grow: 0;
    }
  }

}</style>